var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M10.8934 0.571655H9.88891C9.82061 0.571655 9.75632 0.605138 9.71614 0.660048L5.91123 5.90469L2.10632 0.660048C2.06614 0.605138 2.00186 0.571655 1.93355 0.571655H0.92909C0.842036 0.571655 0.791143 0.670763 0.842036 0.741745L5.56436 7.25201C5.73579 7.48773 6.08668 7.48773 6.25677 7.25201L10.9791 0.741745C11.0313 0.670763 10.9804 0.571655 10.8934 0.571655Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretDown);
export default __webpack_public_path__ + "static/media/icon-caret-down.846ed9c4526bfbf532aa153b00397649.svg";
export { ForwardRef as ReactComponent };